import iClinicApi from 'services/iclinic/iClinicApi';

export const getPaymentSlipLink = () =>
  iClinicApi.get('/payments/payment/get-bank-slip-url/');
